module.exports = __webpack_public_path__ + "static/media/barber.7e1dd7f2.jpeg";